export default __webpack_public_path__ + "static/media/marvel-what-if.e0182259.webp";